import { createContext, useCallback, useContext, useEffect, useState } from "react";
import { api, COMPANY_KEY } from "../lib/api";
import { disablePush } from "../lib/pwa";

const AuthContext = createContext(null);

export const homeFor = (u) => {
  if (!u) return "/connexion";
  if (u.platform_role) return "/admin";
  if (u.memberships?.length) return "/app";
  return "/mon-espace";
};

export function AuthProvider({ children }) {
  const [user, setUser] = useState(null);

  const refresh = useCallback(async () => {
    try {
      const { data } = await api.get("/auth/me");
      setUser(data);
      return data;
    } catch (e) {
      setUser(false);
      return false;
    }
  }, []);

  useEffect(() => {
    refresh();
  }, [refresh]);

  const authenticate = async (path, payload) => {
    const { data } = await api.post(path, payload);
    if (data.mfa_required) {
      return data;
    }
    localStorage.removeItem(COMPANY_KEY);
    setUser(data);
    return data;
  };

  const logout = async () => {
    try {
      await disablePush();
    } catch (e) {
      // push unsubscription is best effort
    }
    try {
      await api.post("/auth/logout");
    } finally {
      localStorage.removeItem(COMPANY_KEY);
      setUser(false);
    }
  };

  return (
    <AuthContext.Provider value={{ user, refresh, authenticate, logout }}>{children}</AuthContext.Provider>
  );
}

export const useAuth = () => useContext(AuthContext);
